import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core'
import { ActivatedRoute, Router } from '@angular/router'
import { FilterOptionModel, FilterableContainer, LinkModel, SearchModel } from '@flocasts/experience-service-types'
import { SearchFiltersService } from 'src/app/singleton-services/search-filters.service'

@Component({
  selector: 'flo-filterable-container',
  templateUrl: './filterable-container-component.html',
  styleUrls: ['./filterable-container-component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FilterableContainerComponent {
  constructor(
    private readonly searchFiltersService: SearchFiltersService,
    private readonly router: Router,
    private readonly ar: ActivatedRoute
  ) {}

  @Input()
  container: FilterableContainer

  @Input()
  isLoading: boolean

  @Output()
  nextPage = new EventEmitter<LinkModel>()

  @Output()
  toggleClicked = new EventEmitter<FilterOptionModel>()

  public handleNextPage(link: LinkModel) {
    this.nextPage.emit(link)
  }

  public handleToggleClicked(toggleOption: FilterOptionModel) {
    this.toggleClicked.emit(toggleOption)
  }

  public handleSearch(search: { searchTerm: string | null; searchModel?: SearchModel }) {
    this.searchFiltersService.updateQueryParams({ search: search.searchTerm, offset: 0 })
  }

  public singleFilterClicked(facets: string) {
    this.router.navigate([], {
      relativeTo: this.ar,
      queryParams: { facets },
      queryParamsHandling: 'merge'
    })
  }
}
